import { render, staticRenderFns } from "./faultAlert.vue?vue&type=template&id=325da44a&scoped=true"
import script from "./faultAlert.vue?vue&type=script&lang=js"
export * from "./faultAlert.vue?vue&type=script&lang=js"
import style0 from "./faultAlert.vue?vue&type=style&index=0&id=325da44a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325da44a",
  null
  
)

export default component.exports